import { AriaAttributes } from 'react';
import * as React from 'react';

import { translate } from '~l10n/client';

import { Link } from '~shared/components/Link';
import { importQuizExcelTemplate } from '~teacher/components/ImportQuizBySpreadsheet/importQuizExcelTemplate';
import { useImportQuizBySpreadsheetInputFile } from '~teacher/components/ImportQuizBySpreadsheet/useImportQuizBySpreadsheetInputFile';

export interface Props extends AriaAttributes {
  id: string;
  isLoading: boolean;
  progress: number;
  isError: boolean;
  onUploadFile: (file: File) => void;
}

export function ImportQuizBySpreadsheetInputFile({
  id,
  isLoading,
  progress,
  onUploadFile,
  ['aria-describedby']: ariaDescribedBy,
  ['aria-labelledby']: ariaLabeledBy,
}: Props) {
  const { fileName, onChange } =
    useImportQuizBySpreadsheetInputFile(onUploadFile);

  if (isLoading) {
    return (
      <div className="flex flex-col gap-2">
        <p className="m-0 pr-6 text-base text-blue-600 leading-8">{fileName}</p>
        <div className="rounded-3 h-4 bg-grey-100 w-full p-0">
          <div
            className="rounded-3 bg-cyan-600 h-4"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
    );
  }
  return (
    <div className="flex justify-between items-center">
      <label className="group relative focus:z-10 px-4 py-2 m-0 border-0 rounded-2 text-sm leading-8 font-sans font-600 appearance-none outline-none select-none transition ease-in-out duration-100 cursor-pointer text-cyan-700 hover:bg-cyan-100 focus:bg-cyan-100 hover:text-cyan-800 focus:text-cyan-800 bg-cyan-50">
        {translate('Choose File')}
        <input
          id={id}
          aria-labelledby={ariaLabeledBy}
          aria-describedby={ariaDescribedBy}
          className="sr-only"
          accept=".xls, .xlsx"
          type="file"
          onChange={onChange}
        />
      </label>
      <div className="text-sm font-600 ">
        <Link
          href={importQuizExcelTemplate}
          indicatorProps={{ notOffset: true, isInset: false }}
          includeCommonStyles
          className="font-600 text-cyan-700 hocus:text-cyan-600"
        >
          {translate('Download Template')}
        </Link>
      </div>
    </div>
  );
}
